import createReducer from "../../createReducer";
import { hubspotStatusHandlers } from "../handlers";
import { IHubspotStatusState } from "../types";

export const hubspotStatus: IHubspotStatusState = {
    isLoading: false,
    error: null,
    status: null,
    message: null,
    success: null,
};

export default createReducer(hubspotStatus, hubspotStatusHandlers);
